"use strict";

define(['marionette', 'jquery'], function (Marionette, $) {
  return Marionette.ItemView.extend({
    template: false,
    ui: {
      dropdownButtons: ['.js-menu-dropdown-toggle', '.main-navigation--profile-link > .flag', '.main-navigation--profile-link > .flag a'],
      dropdownContainer: '.dropdown'
    },
    events: {
      'click @ui.dropdownButtons': 'toggleDropdown',
      'click @ui.dropdownContainer': 'onDropdownContainerClick'
    },
    onRender: function onRender() {
      return this.bindDocumentClick();
    },
    bindDocumentClick: function bindDocumentClick() {
      $(window).on('click.dropdown-close', $.proxy(this.onDocumentClick, this));
      return this;
    },
    onDropdownContainerClick: function onDropdownContainerClick(e) {
      e.stopPropagation();
    },
    onDocumentClick: function onDocumentClick(event) {
      var $target = $(event.target);

      if (!$target.closest('.dropdown')[0]) {
        this.closeDropdown();
      }

      return this;
    },
    closeDropdown: function closeDropdown() {
      this.$el.find('.dropdown').addClass('is-hidden');
      this.$el.find('.dropdown-is-active').removeClass('dropdown-is-active');
    },
    toggleDropdown: function toggleDropdown(e) {
      e.stopPropagation();
      e.preventDefault();
      var $dropdown = $(e.currentTarget).closest('li').find('.dropdown');

      if (!$dropdown.length) {
        $dropdown = $(e.currentTarget).closest('section').find('.dropdown');
      }

      var visibilityState = $dropdown.toggleClass('is-hidden').is(':visible');

      if (visibilityState) {
        this.$el.find('.dropdown').not($dropdown).addClass('is-hidden');
      }

      $(e.currentTarget).parents('li[class*=main-navigation--]').toggleClass('dropdown-is-active').siblings().removeClass('dropdown-is-active');
      return this;
    }
  });
});